import { TRANSFORMERS, $convertFromMarkdownString, type TextMatchTransformer } from '@lexical/markdown';
import { LexicalNode } from 'lexical';
import { $createBeautifulMentionNode, $createZeroWidthNode } from 'lexical-beautiful-mentions';
import { DYNAMIC_FIELD_TRIGGER } from '../constants';
import { DynamicFieldAttributes } from '../molecules/dynamic-field-action';
import { $isDynamicFieldNode, DynamicFieldNode } from '../nodes/dynamic-field-node';

export const dynamicFieldTransform = (fields: DynamicFieldAttributes[], trigger: string): TextMatchTransformer => ({
  dependencies: [DynamicFieldNode],
  export: (node: LexicalNode) => {
    if (!$isDynamicFieldNode(node)) {
      return null;
    }
    const textContent = node.getValue();
    return `${textContent}`;
  },
  importRegExp: /{{(.*?)}}/,
  regExp: /{{(.*?)}}/,
  replace: (textNode, match) => {
    const content = match[1];
    const zeroWidthNode = $createZeroWidthNode();

    const value = `{{${content}}}`;
    const dynamicField = fields.find((field) => field.symbol === value);
    const variableNode = $createBeautifulMentionNode(DYNAMIC_FIELD_TRIGGER, value, {
      label: dynamicField?.label ?? '',
      val: dynamicField?.val ?? '',
    });
    textNode.replace(variableNode).insertBefore(zeroWidthNode);
  },
  trigger: trigger,
  type: 'text-match',
});

/**
 * Note: This can be used only inside the context of the RichTextEditor
 */
export const $convertFromMarkdownStringWithDF = (
  content: string,
  dynamicFields: DynamicFieldAttributes[],
  trigger: string
) => {
  $convertFromMarkdownString(content, [...TRANSFORMERS, dynamicFieldTransform(dynamicFields, trigger)]);
  return null;
};
